module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "characterjob-with-description"
    }
  }, [_c('h1', [_c('strong', [_vm._v("Character/Job with Description")])]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "zebra-ice-through-axiton-andromeda"
    }
  }, [_c('h2', [_vm._v("Z"), _c('strong', [_vm._v("ebra-Ice through Axiton, Andromeda")])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "99%",
      "text-align": "left"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "65%"
    }
  })]), _vm._v(" "), _c('thead', [_c('tr', {
    staticClass: "header"
  }, [_c('th', {
    staticStyle: {
      "border-right": "none !important"
    }
  }, [_vm._v("Character")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "border-left": "none !important"
    }
  }, [_vm._v("Job with Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("Alan Baxter")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Alan Baxter")]), _vm._v(" "), _c('p', [_vm._v("A pterodactyl lead scientist")])])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("Anastazia Roxeski")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Anastazia Roxeski")]), _vm._v(" "), _c('p', [_vm._v("A five-star Lepi-Spot Ukrainian General serving as the Ukrainian Ambassador to du Plessis with an intergalactic war-charter manifest")])])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("Ukrainian Senator Volodymyr Kovalevsky")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Lepi-Spot Ukrainian Senator Volodymyr Kovalevsky")]), _vm._v(" "), _c('p', [_vm._v("A short and stocky hot tempered Lepi-Spot Ukrainian Senator Volodymyr Kovalevsky")])])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("Ukrainian special agent Natalia Kolesnikov")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Ukrainian special agent Natalia Kolesnikov")]), _vm._v(" "), _c('p', [_vm._v("A Ukrainian Lepi-Spot special agent Natalia Kolesnikov")])])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("Margaretta du Plessis")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Madam Prime Minister")]), _vm._v(" "), _c('p', [_vm._v("A short and fiery hot-tempered blonde with an intergalactic war-charter manifest")])])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("Her Majesty Queen Belena Kozlowski")]), _vm._v(" "), _c('td', [_vm._v("Euro-Intergalactic Queen Belena Kozlowski")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("Craig Kawasaki-kiva")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Pterodactyl, and Democratic Leader of the Opposition")]), _vm._v(" "), _c('p', [_vm._v("A five-foot silver-coloured socialist pterodactyl with a real hot temper who’s eager to run the galaxy")])])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("Prime Minister Gavin Axon")]), _vm._v(" "), _c('td', [_vm._v("Byxin Prime Minister Gavin Axon")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("Ben Banks")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Saxon Speaker of the House")]), _vm._v(" "), _c('p', [_vm._v("A six-foot tall liberal martial-arts and bodybuilder with light-brown hair and olive-green eyes, who wants everyone to know everyone’s business")])])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("Randy Gibson")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Intergalactic Network News")]), _vm._v(" "), _c('p', [_vm._v("A short liberal redhead with an intergalactic agenda")])])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("Alexandria Warberg")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Lepi-Spot and Leader of the Liberals")]), _vm._v(" "), _c('p', [_vm._v("A short fiery and war-mongering yellow skinned leopard being with two thousand indigo spots on her body who speaks twenty-seven Euro languages")])])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("Aeon Gilbert")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Lepi-Spot Intergalactic Warrior Intelligence Officer")]), _vm._v(" "), _c('p', [_vm._v("A warrior intelligence officer and war-mongering yellow skinned leopard being with two thousand indigo spots on his body who speaks twenty-seven Euro languages")])])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("Beth Rixon")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Intergalactic Lepi-Spot Intelligence Chief")]), _vm._v(" "), _c('p', [_vm._v("A warrior intelligence chief and war-mongering yellow skinned leopard being with two thousand indigo spots on his body who speaks twenty-seven Euro languages")])])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("Gavin Axon")]), _vm._v(" "), _c('td', [_vm._v("Byxin’s Prime Minister Gavin Axon of Andromeda")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("Anita Fire-Burger")]), _vm._v(" "), _c('td', [_vm._v("SASA Receptionist")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("Ely O’Grady")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Robotics & Space-age Expert")]), _vm._v(" "), _c('p', [_vm._v("A space-age technologies expert and an electronics specialist in flying-cars including robotics")])])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("Paulo dos Santos")]), _vm._v(" "), _c('td', [_vm._v("SASA Androids Production Lead")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("Rupert du Plessis")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Couturier")]), _vm._v(" "), _c('p', [_vm._v("A short and stocky platinum blonde fashion couturier")])])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("President Paulo de Oliveira")]), _vm._v(" "), _c('td', [_vm._v("Brazilian President Paulo de Oliveira")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("Alice Rankle")]), _vm._v(" "), _c('td', [_vm._v("Pterodactyl and Democratic Leader of the Opposition Alice Rankle")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("Supreme Court Judge Andria Spikes")]), _vm._v(" "), _c('td', [_vm._v("Supreme Court Judge Andria Spikes")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("Congressman (D) Paul Spikes")]), _vm._v(" "), _c('td', [_vm._v("Democratic Congressman for Virginia")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("Senator (R) Alexi Novinsky")]), _vm._v(" "), _c('td', [_vm._v("Republican State Senator Alexi Novinsky")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("Wendy Spikes")]), _vm._v(" "), _c('td', [_vm._v("Paul Spikes’ wife")])]), _vm._v(" "), _c('tr', {
    staticClass: "odd"
  }, [_c('td', [_vm._v("US Republican President Swartz")]), _vm._v(" "), _c('td', [_vm._v("US Republican President Swartz")])]), _vm._v(" "), _c('tr', {
    staticClass: "even"
  }, [_c('td', [_vm._v("Bettie Spikes")]), _vm._v(" "), _c('td', [_vm._v("Miami TV CEO and owner")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0